import { t, Trans } from '@lingui/macro'
import {
  Box,
  ButtonClean,
  ButtonDanger,
  Spinner,
  Text
} from 'front-end/src/components'
import { Modal } from 'front-end/src/components/common/modal/Modal'
import { flatten } from 'lodash'
import React from 'react'
import { useCustomSmtpDisableWarningQuery } from './CustomSmtpDisableWarning.codegen'
import { RelatedCampaignsListWithAuthors } from './RemoveEmailIdentityModal'
import { RelatedCampaignDetailsFragment } from 'front-end/src/pages/account/notifications-tab/RemoveEmailIdentityModal.codegen'

export const CustomSmtpDisableWarning: React.FC<{
  reject: () => any
  resolve: () => any
}> = ({ reject, resolve }) => {
  const { data, loading } = useCustomSmtpDisableWarningQuery()

  const emailIdentities =
    data?.admin?.organisation?.custom_smtp
      ?.emailIdentitiesVerifiedAfterValidation

  const campaigns = flatten<RelatedCampaignDetailsFragment>(
    emailIdentities?.map((identity) => identity.relatedCampaigns)
  )

  return (
    <Modal
      newDesign
      size="WIDE"
      header={t`Are you sure you want to disable Custom SMTP?`}
      controls={
        <>
          <ButtonClean onClick={reject}>
            <Trans>Cancel</Trans>
          </ButtonClean>
          <ButtonDanger onClick={resolve}>
            <Trans>Disable</Trans>
          </ButtonDanger>
        </>
      }
      onHide={reject}
    >
      {loading && <Spinner />}
      {emailIdentities && emailIdentities.length > 0 && (
        <>
          <Trans>The following senders will need to be re-verified: </Trans>
          <Box mb={'16px'} mt="8px">
            {emailIdentities.map((identity) => (
              <Text key={identity.id} ml="14px">
                <strong>{identity.name}</strong>({identity.email})
              </Text>
            ))}
          </Box>
        </>
      )}
      {campaigns.length > 0 && (
        <>
          <Trans>
            These senders are currently in use in the following campaigns:{' '}
          </Trans>
          <RelatedCampaignsListWithAuthors campaigns={campaigns} />
        </>
      )}
    </Modal>
  )
}
